function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M41.5 83C18.6178 83 0 64.3822 0 41.5C0 18.6178 18.6178 0 41.5 0C64.3822 0 83 18.6178 83 41.5C83 64.3822 64.3822 83 41.5 83ZM41.5 8.37281C23.2462 8.37281 8.37281 23.2462 8.37281 41.5C8.37281 59.7538 23.2462 74.6272 41.5 74.6272C59.7538 74.6272 74.6272 59.7538 74.6272 41.5C74.6272 23.1942 59.7538 8.37281 41.5 8.37281Z",
  fill: "current"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M30.7869 35.4153C30.7349 35.9354 30.4749 36.3514 30.0588 36.6635C29.6428 36.9755 29.1747 37.1315 28.6547 37.0275C28.1346 36.9755 27.7186 36.7155 27.4066 36.2994C26.2105 34.7393 25.0143 33.9072 23.8702 33.9072C22.2061 33.9592 20.6459 35.6234 20.1779 36.1954C19.8138 36.7155 19.2418 37.0275 18.6177 37.0275C18.2017 37.0275 17.8377 36.9235 17.5256 36.6635C17.1096 36.4034 16.8496 35.9354 16.7455 35.4674C16.6415 34.9473 16.7455 34.4273 17.0576 34.0632C17.1616 33.9072 19.8138 30.2148 23.7662 30.1108C26.2105 30.1108 28.4467 31.359 30.4749 33.9592C30.7349 34.3753 30.8909 34.8953 30.7869 35.4153Z",
  fill: "current"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M66.2543 35.4153C66.2023 35.9354 65.9423 36.4034 65.5262 36.6635C65.1102 36.9755 64.5901 37.1315 64.1221 37.0275C63.6021 36.9755 63.186 36.7155 62.874 36.2994C61.6779 34.7393 60.4817 33.9072 59.3376 33.9072C57.6215 33.9592 56.1133 35.6234 55.6453 36.1954C55.2812 36.7155 54.7092 37.0275 54.0851 37.0275C53.7211 37.0275 53.3051 36.9235 52.993 36.6635C52.577 36.4034 52.317 35.9354 52.213 35.4674C52.1609 34.9473 52.265 34.4273 52.525 34.0632C52.629 33.9072 55.2812 30.2148 59.2336 30.1108C61.6259 30.1108 63.9141 31.359 65.8903 33.9592C66.2023 34.3753 66.3583 34.8953 66.2543 35.4153Z",
  fill: "current"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M45.8164 55.8533C45.8164 58.8696 43.9962 61.3138 41.708 61.3138C39.4198 61.3138 37.5996 58.8696 37.5996 55.8533C37.5996 52.837 39.4198 47.4805 41.708 47.4805C43.9962 47.4805 45.8164 52.837 45.8164 55.8533Z",
  fill: "current"
});

function SvgHappySogui(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 83,
    viewBox: "0 0 83 83",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHappySogui);
export default __webpack_public_path__ + "static/media/HappySogui.806b2364.svg";
export { ForwardRef as ReactComponent };